import { ArrowDownIcon, ArrowUpIcon, CheckIcon, CloseIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
  Button,
  Flex,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Checkbox,
  Box,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Spinner
} from '@chakra-ui/react';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import FichasController from 'controllers/Fichas/FichasController';
import PerguntasController from "controllers/Perguntas/PerguntasController";
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PostProcessmentDrawer } from './post-processment';

function PerguntasView() {
  const [data, setData] = useState([]);
  const [searchednome, setSearchedNome] = useState([]);
  const [searcheduser, setSearchedUser] = useState([]);
  const [searchcontext, setSearchcontext] = useState([]);
  const [newNome, setNewNome] = useState("");
  const [newContext, setNewContext] = useState("");
  const [newModel, setNewModel] = useState("");
  const [newSystem, setNewSystem] = useState("");
  const [newUser, setNewUser] = useState("");
  const textColor = useColorModeValue("gray.700", "white");
  const { Audit_id } = useParams();
  const history = useHistory();
  const [tipoAvaliacao, setTipoAvaliacao] = useState("semNota");
  const [newNota, setNewNota] = useState("");
  const [newWords, setNewWords] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const pathname = history.location.pathname;
  const numeros = pathname.match(/\d+/);
  const [auditName, setAuditName] = useState("");
  const [contextName, setContextName] = useState("");
  const [context, setContext] = useState("");
  const [value, setValue] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isSaving, setIsSaving] = useState(false);

  const handleAddContext = async () => {
    setIsSaving(true);
    try {
      const response = await PerguntasController.AddContext(newContext)
      setNewContext("");
      setContext("");
      onClose();
      const updatedContext = await PerguntasController.SearchedContext();
      setSearchcontext(updatedContext);
    } catch (error) {
      console.error("Erro ao adicionar contexto:", error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleChange = (event) => {
    setValue(event.target.checked ? 1 : 0);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await PerguntasController.ListPerguntaswithprompt(Audit_id)
        setData(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [Audit_id]);

  useEffect(() => {
    const fetchDataID = async () => {
      try {
        const response = await FichasController.ListFichasByID(Audit_id)
        setAuditName(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDataID();
  }, [Audit_id]);

  useEffect(() => {
    const fetchDataContext = async () => {
      try {
        const response = await FichasController.ShowContext(Audit_id);
        if (response && response.context) {
          setContextName(response.context);
        } else {
          setContextName("");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setContextName("");
      }
    };
    fetchDataContext();
  }, [Audit_id]);

  useEffect(() => {
    const fetchDataNome = async () => {
      try {
        const response = await PerguntasController.SearchedNome()
        setSearchedNome(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDataNome();
  }, [Audit_id]);

  useEffect(() => {
    const fetchDataUser = async () => {
      try {
        const response = await PerguntasController.SearchedUser()
        setSearchedUser(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDataUser();
  }, [Audit_id]);

  useEffect(() => {
    const fetchDataContext = async () => {
      try {
        const response = await PerguntasController.SearchedContext()
        setSearchcontext(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDataContext();
  }, [Audit_id]);

  const PutFicha = async () => {
    try {
      await PerguntasController.PutContext(Audit_id, auditName, context);
      const updatedPerguntas = await PerguntasController.ListPerguntaswithprompt(Audit_id);
      setData(updatedPerguntas);
      const updatedNome = await PerguntasController.SearchedNome();
      setSearchedNome(updatedNome);
      const updateUser = await PerguntasController.SearchedUser();
      setSearchedUser(updateUser);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const addPergunta = async () => {
    try {
      setIsLoading(true);
      let notaValue = 0;

      if (tipoAvaliacao === "comNota") {
        notaValue = parseFloat(newNota);
        if (isNaN(notaValue)) {
          notaValue = 0;
        }
      }

      const response = await PerguntasController.AddPerguntas(newNome, newModel, newSystem, newUser, Audit_id, notaValue, context, newWords, value);
      if (response) {
        const updatedPerguntas = await PerguntasController.ListPerguntaswithprompt(Audit_id);
        const updatedNome = await PerguntasController.SearchedNome()
        const updateUser = await PerguntasController.SearchedUser()
        setData(updatedPerguntas);
        setSearchedNome(updatedNome);
        setSearchedUser(updateUser);
        setNewNome("");
        setNewModel("");
        setNewSystem("");
        setNewUser("");
        setNewNota("");
        setNewContext("");
        setNewWords("");
        setContext("");
        setValue(0);
      }
    } catch (error) {
      console.error("Error adding new pergunta:", error);
      setError("Failed to add new pergunta. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = newNome && newUser;

  return (
    <Flex direction={['column', 'column']} height={"100%"} width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} mb={[4, 4, 0]}>
        <Flex justify="space-between" mb={4}>
          <Button colorScheme="blue" onClick={() => history.goBack()}>
            Voltar
          </Button>
          <Button colorScheme="blue" onClick={onOpen}>
            Adicionar Contexto
          </Button>
        </Flex>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Adicionar Novo Contexto</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Input
                placeholder="Digite o novo contexto"
                value={newContext}
                onChange={(e) => setNewContext(e.target.value)}
                _placeholder={{ color: textColor }}
              />
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={handleAddContext} isLoading={isSaving}>
                Salvar
              </Button>
              <Button variant="ghost" onClick={onClose}>
                Cancelar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <CardHeader p='6px 0px 22px 0px'>
          <Flex flexDirection="column" mb={4}>
            <Text fontSize='xl' color={textColor} fontWeight='bold' mt={3}>
              Dados da ficha
            </Text>
            <Flex wrap="wrap" gridGap={4} mt={4}>
              <Input
                type="text"
                placeholder={auditName?.Nome ?? ""}
                onChange={(e) => setAuditName(e.target.value)}
                minWidth={"450"}
                _placeholder={{ color: textColor }}
              />
              <Button colorScheme="blue" onClick={PutFicha}>Salvar Ficha</Button>
              <Box minWidth={"450"}></Box>
            </Flex>
            <Flex flexDirection="column" mb={4}>
              <Text fontSize='xl' color={textColor} fontWeight='bold' mt={3}>
                Adicionar Pergunta
              </Text>
              <Flex wrap="wrap" gridGap={4} mt={4}>
                <Input
                  type="text"
                  placeholder="Faça sua pergunta"
                  value={newNome}
                  onChange={(e) => setNewNome(e.target.value)}
                  list="searchNomeList"
                />
                <datalist id="searchNomeList">
                  {searchednome.map((item, index) => (
                    <option key={index} value={item.Nome}></option>
                  ))}
                </datalist>
                <Input
                  type="text"
                  placeholder="Formule a pergunta com suas palavras"
                  value={newUser}
                  onChange={(e) => setNewUser(e.target.value)}
                  list="searchQuestionUserList"
                />
                <datalist id="searchQuestionUserList">
                  {searcheduser.map((item, index) => (
                    <option key={index} value={item.user}></option>
                  ))}
                </datalist>
                <Select
                  value={tipoAvaliacao}
                  onChange={(e) => setTipoAvaliacao(e.target.value)}
                >
                  <option value="semNota">Sem Nota</option>
                  <option value="comNota">Com Nota</option>
                </Select>
                {tipoAvaliacao === "comNota" && (
                  <Input
                    type="text"
                    placeholder="Digite a nota"
                    value={newNota}
                    onChange={(e) => setNewNota(e.target.value)}
                  />
                )}
                {tipoAvaliacao === "comNota" && (
                  <Input
                    type="text"
                    placeholder="Digite as palavras que a nota deve ser máxima (Separado por  ' , ')"
                    value={newWords}
                    onChange={(e) => setNewWords(e.target.value)}
                  />
                )}
                {tipoAvaliacao === "comNota" && (
                  <Box>
                    <Checkbox
                      isChecked={value === 1}
                      onChange={handleChange}
                    >
                      Pergunta eliminatória?
                    </Checkbox>
                  </Box>
                )}
                <Input
                  type="text"
                  placeholder={"Digite o contexto da pergunta"}
                  value={context}
                  onChange={(e) => setContext(e.target.value)}
                  minWidth={"450"}
                  list="searchContextList"
                />
                <datalist id="searchContextList">
                  {searchcontext.map((item, index) => (
                    <option key={index} value={item.context}></option>
                  ))}
                </datalist>
                <Button
                  colorScheme="blue"
                  onClick={addPergunta}
                  isLoading={isLoading}
                  isDisabled={!isFormValid}
                >
                  Adicionar
                </Button>
              </Flex>
            </Flex>
          </Flex>
          {error && <Text color="red.500">{error}</Text>}
        </CardHeader>
        <CardBody>
          {isLoading ? <Spinner color="green" /> :
            <Table variant="striped" colorScheme="gray.800" size="md">
              <Thead>
                <Tr>
                  <Th>Nome</Th>
                  <Th>Prompt</Th>
                  <Th>Nota</Th>
                  <Th>Pós processamento</Th>
                  <Th>Words</Th>
                  <Th>eliminatória</Th>
                  <Th>Contexto</Th>
                  <Th>Ações</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data.map((pergunta) => (
                  <PerguntaRow
                    key={pergunta.id}
                    pergunta={pergunta}
                    setData={setData}
                    data={data}
                  />
                ))}
              </Tbody>
            </Table>
          }
        </CardBody>
      </Card>
    </Flex>
  );
}

function PerguntaRow({ pergunta, setData, data }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editNome, setEditNome] = useState(pergunta.Nome);
  const [editUser, setEditUser] = useState(pergunta.user);
  const [editNota, setEditNota] = useState(pergunta.nota);
  const [editContext, setEditContext] = useState(pergunta.context);
  const [editWords, setEditWords] = useState(pergunta.words);
  const [editQualifier, setEditQualifier] = useState(pergunta.qualifier);

  const handleDelete = async () => {
    try {
      const response = await PerguntasController.DeletePerguntas(pergunta.id);
      if (response) {
        const updatedData = data.filter(item => item.id !== pergunta.id);
        setData(updatedData);
      }
    } catch (error) {
      console.error("Error deleting pergunta:", error);
    }
  };

  const handleUpdate = async (pergunta, newPosition, swapPositionId) => {
    try {
      await PerguntasController.PutPerguntas(
        pergunta.id,
        editNome,
        editContext,
        editNota,
        editUser,
        editWords,
        editQualifier,
        newPosition
      );

      if (swapPositionId) {
        const otherPergunta = data.find((item) => item.id === swapPositionId);
        if (otherPergunta) {
          await PerguntasController.PutPerguntas(
            otherPergunta.id,
            otherPergunta.Nome,
            otherPergunta.context,
            otherPergunta.nota,
            otherPergunta.user,
            otherPergunta.words,
            otherPergunta.qualifier,
            pergunta.question_seq
          );
        }
      }

      const updatedData = data.map((item) => {
        if (item.id === pergunta.id) {
          return {
            ...item,
            Nome: editNome,
            user: editUser,
            nota: editNota,
            context: editContext,
            words: editWords,
            qualifier: editQualifier,
            question_seq: newPosition
          };
        }
        if (item.id === swapPositionId) {
          return { ...item, question_seq: pergunta.question_seq };
        }
        return item;
      }).sort((a, b) => a.question_seq - b.question_seq);

      setData(updatedData);
      setIsEditing(false);
    } catch (error) {
      console.error("Error updating pergunta:", error);
    }
  };

  const moveUp = async (pergunta) => {
    if (pergunta.question_seq > 1) {
      const newPosition = pergunta.question_seq - 1;
      const swapPergunta = data.find(item => item.question_seq === newPosition);
      await handleUpdate(pergunta, newPosition, swapPergunta?.id);
    }
  };

  const moveDown = async (pergunta) => {
    const maxPosition = Math.max(...data.map(item => item.question_seq));
    if (pergunta.question_seq < maxPosition) {
      const newPosition = pergunta.question_seq + 1;
      const swapPergunta = data.find(item => item.question_seq === newPosition);
      await handleUpdate(pergunta, newPosition, swapPergunta?.id);
    }
  };

  return (
    <Tr>
      <Td>{isEditing ? <Textarea value={editNome} onChange={(e) => setEditNome(e.target.value)} /> : pergunta.Nome}</Td>
      <Td>{isEditing ? <Textarea value={editUser} onChange={(e) => setEditUser(e.target.value)} /> : pergunta.user}</Td>
      <Td>
        {isEditing ? (
          <Input value={editNota} onChange={(e) => setEditNota(e.target.value)} />
        ) : (
          pergunta.nota
        )}
      </Td>
      <Td>{pergunta.reproc_result ?? '-'}</Td>
      <Td>
        {isEditing ? (
          <Input style={{ width: "100%" }} value={editWords} onChange={(e) => setEditWords(e.target.value)} />
        ) : (
          pergunta.words
        )}
      </Td>
      <Td>
        {isEditing ? (
          <Checkbox
            isChecked={editQualifier === 1}
            onChange={() => setEditQualifier(editQualifier === 1 ? 0 : 1)}
          >
            Eliminatória?
          </Checkbox>
        ) : (
          (pergunta.qualifier === 1 ? "Sim" : "Não")
        )}
      </Td>
      <Td>
        {isEditing ? (
          <Input value={editContext} onChange={(e) => setEditContext(e.target.value)} />
        ) : (
          pergunta.context
        )}
      </Td>
      <Td>
        {isEditing ? (
          <nobr>
            <Button
              leftIcon={<CheckIcon />}
              onClick={() => handleUpdate(pergunta, pergunta.question_seq, null)}
            ></Button>
            <Button leftIcon={<CloseIcon />} onClick={() => setIsEditing(false)}></Button>
          </nobr>
        ) : (
          <nobr>
            <PostProcessmentDrawer questionId={pergunta.id} />
            <Button onClick={() => setIsEditing(true)}><EditIcon /></Button>
            <Button onClick={handleDelete}><DeleteIcon /></Button>
            <Button onClick={() => moveUp(pergunta)} leftIcon={<ArrowUpIcon />} />
            <Button onClick={() => moveDown(pergunta)} leftIcon={<ArrowDownIcon />} />
          </nobr>
        )}
      </Td>
    </Tr>
  );
}

export default PerguntasView;